import React, { useCallback } from 'react';
import { DateUtils } from '@vectord/utils';
import { Tappable } from '@vectord/components';
import { useDispatch, batch } from 'react-redux';
import classNames from 'classnames';

import {
  RECORDING_REQUEST_MODAL_STAGE,
  setModalStage,
  setRecordingRequest,
} from 'features/recording';
import styles from './RecordingRequestRow.module.scss';
import TableCell from 'components/TableCell';
import TableRow from 'components/TableRow';

export default function RecordingRequestRow({ recordingRequest }) {
  const dispatch = useDispatch();
  const { mentee, meta, reason, created_at, attachment } = recordingRequest;
  const {
    overall_attendance: menteeAttendance,
    solved_percentage: problemSolvingPercentage,
    created_at: courseJoiningDate,
  } = mentee || {};
  const {
    instructor_name: instructorName,
    name: moduleName,
    current_module: currentModule,
  } = meta || {};
  const openLectureNamesModal = useCallback(() => {
    batch(() => {
      dispatch(setRecordingRequest(recordingRequest));
      dispatch(setModalStage(RECORDING_REQUEST_MODAL_STAGE.moduleDetailStage));
    });
  }, [dispatch, recordingRequest]);

  const openRequestActionsModal = useCallback(() => {
    batch(() => {
      dispatch(setRecordingRequest(recordingRequest));
      dispatch(setModalStage(RECORDING_REQUEST_MODAL_STAGE.actionStage));
    });
  }, [dispatch, recordingRequest]);

  return (
    <TableRow className={styles.requestTableRow}>
      <TableCell>
        Name: {mentee.user.name}
        <br />
        Email: {mentee.user.email}
        <br />
        Problem Solving Percentage: {problemSolvingPercentage || 'N/A'}
        <br />
        Attendance: {menteeAttendance || 'N/A'}
        <br />
        Course Joining Date:{' '}
        {courseJoiningDate ? DateUtils.toDDMMMYYYY(courseJoiningDate) : 'N/A'}
        <br />
        Current Module: {currentModule}
      </TableCell>
      <TableCell>
        <div className={classNames(styles.reasonSection, 'scroll')}>
          {reason}
        </div>
      </TableCell>
      <TableCell>
        {DateUtils.toDDMMMYYYY(created_at)} <br />
        {DateUtils.toHHmm(created_at)}
      </TableCell>
      <TableCell>
        <a
          href={attachment?.link}
          className="link"
          target="_blank"
          rel="noreferrer"
        >
          Attachment
        </a>
      </TableCell>
      <TableCell className={styles.recordingList}>
        {moduleName} <br />
        instructor: <span className="p-v-5">{instructorName}</span> <br />
        <Tappable
          onClick={openLectureNamesModal}
          className={classNames(styles.lectureList, 'link')}
        >
          Lecture List
        </Tappable>
      </TableCell>
      <TableCell className={styles.actions}>
        <Tappable
          onClick={openRequestActionsModal}
          className="primary bold"
        >
          Action
        </Tappable>
      </TableCell>
    </TableRow>
  );
}
